module.exports = __webpack_public_path__ + "static/media/capture_session_03.70387966.png";